/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleProductivityListUpdate
 */
export interface VehicleProductivityListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleManufacturer?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleModel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleEngineType?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleManufactureYear?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleLastSynchronizedAt?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleTypeLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    departmentLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProductivityListUpdate
     */
    vehicleGroupLabel?: boolean | null;
}

/**
 * Check if a given object implements the VehicleProductivityListUpdate interface.
 */
export function instanceOfVehicleProductivityListUpdate(value: object): value is VehicleProductivityListUpdate {
    return true;
}

export function VehicleProductivityListUpdateFromJSON(json: any): VehicleProductivityListUpdate {
    return VehicleProductivityListUpdateFromJSONTyped(json, false);
}

export function VehicleProductivityListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleProductivityListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
        'vehicleManufacturer': json['vehicleManufacturer'] == null ? undefined : json['vehicleManufacturer'],
        'vehicleModel': json['vehicleModel'] == null ? undefined : json['vehicleModel'],
        'vehicleEngineType': json['vehicleEngineType'] == null ? undefined : json['vehicleEngineType'],
        'vehicleManufactureYear': json['vehicleManufactureYear'] == null ? undefined : json['vehicleManufactureYear'],
        'vehicleLastSynchronizedAt': json['vehicleLastSynchronizedAt'] == null ? undefined : json['vehicleLastSynchronizedAt'],
        'vehicleTypeLabel': json['vehicleTypeLabel'] == null ? undefined : json['vehicleTypeLabel'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
        'vehicleGroupLabel': json['vehicleGroupLabel'] == null ? undefined : json['vehicleGroupLabel'],
    };
}

export function VehicleProductivityListUpdateToJSON(json: any): VehicleProductivityListUpdate {
    return VehicleProductivityListUpdateToJSONTyped(json, false);
}

export function VehicleProductivityListUpdateToJSONTyped(value?: VehicleProductivityListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'vehicleManufacturer': value['vehicleManufacturer'],
        'vehicleModel': value['vehicleModel'],
        'vehicleEngineType': value['vehicleEngineType'],
        'vehicleManufactureYear': value['vehicleManufactureYear'],
        'vehicleLastSynchronizedAt': value['vehicleLastSynchronizedAt'],
        'vehicleTypeLabel': value['vehicleTypeLabel'],
        'departmentLabel': value['departmentLabel'],
        'vehicleGroupLabel': value['vehicleGroupLabel'],
    };
}

